import React from "react";
import { useLanguage } from "../contexts/LanguageContext";
import { ROW_TAG_CLASS } from "./conversationLayout";

// Etiqueta das conversas que um bot comecou. Um `bot` em falta (um backend anterior ao PR #342) le-se
// como falso. O estilo e o da etiqueta do nome do chat na linha da lista.
// `hidden`: fora da arvore de acessibilidade, para a linha da lista, onde a palavra ja vai na frase
// sr-only do estado. `inSubtitle`: altura de 14px, para caber na linha `leading-4` do subtitulo
// do cabecalho sem o fazer crescer.
const ConversationBotTag = ({ bot, hidden = false, inSubtitle = false }) => {
  const { translate } = useLanguage();
  if (!bot) return null;
  return (
    <span
      className={`${ROW_TAG_CLASS} ${inSubtitle ? "leading-[14px]" : "leading-4"}`}
      style={{ color: "var(--color-text-secondary)" }}
      title={translate("conversationsBotTitle")}
      aria-hidden={hidden ? "true" : undefined}
    >
      {translate("conversationsBot")}
    </span>
  );
};

export default ConversationBotTag;
